import { render, staticRenderFns } from "./PurchaseView.vue?vue&type=template&id=20e2c8f4&scoped=true&"
import script from "./PurchaseView.vue?vue&type=script&lang=js&"
export * from "./PurchaseView.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseView.vue?vue&type=style&index=0&id=20e2c8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2c8f4",
  null
  
)

export default component.exports